import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionButton } from 'ui/actionButton/ActionButton';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { ArchiveOwnerProps } from './ArchiveOwner.types';

export const ArchiveOwner = ({
  selectedOwner,
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
}: ArchiveOwnerProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const canEditOwner = perms?.[Functionality.KARTY_POSIADACZE]?.edit;

  return (
    <>
      <ActionButton
        type="archive"
        onClick={onModalOpen}
        disabled={!canEditOwner}
        customTooltipText={!canEditOwner ? formatMessage({ id: AppMessages['common.noPermissions'] }) : undefined}
      />

      <ActionModal
        header={formatMessage({ id: AppMessages['owner.archive.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        submitButtonDisabled={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['owner.archive.submitButton'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['owner.archive.text'] })}{' '}
          {`${selectedOwner.nazwisko || ''} ${selectedOwner.imie || ''}`}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['owner.archive.confirm'] })}</ActionModal.Text>

        <br />

        <ActionModal.Text>{formatMessage({ id: AppMessages['owner.archive.description'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
